import { createMemo } from 'react-use'
import { reduce } from 'lodash-es'
import useGuidToCrossSection from './useGuidToCrossSection'

const guidToCrossSectionDimensions = (guidToCrossSection: Record<string, CrossSection>) => {
  return reduce(
    Object.entries(guidToCrossSection),
    (col, [guid, crossSection]) => ({
      ...col,
      [guid]: { height: crossSection.shape.height, width: crossSection.shape.width },
    }),
    {} as Record<string, { height: number; width: number }>,
  )
}

const useMapGuidToCrossSectionDimensions = createMemo(guidToCrossSectionDimensions)

const useGuidToCrossSectionDimensions = () => {
  const guidToCrossSection = useGuidToCrossSection()

  return useMapGuidToCrossSectionDimensions(guidToCrossSection)
}

export default useGuidToCrossSectionDimensions
